// extracted by css-extract-rspack-plugin
export default {"root":"wBl6wk3XLYQ8CYkS"};